var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 124,
    viewBox: "0 0 102 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 4L100 44V110C100 117.732 93.732 124 86 124H14C6.26801 124 0 117.732 0 110V18C0 10.268 6.26801 4 14 4H60Z",
    fill: "url(#paint0_linear_0_62)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 44H74.7071C66.9751 44 60 37.0249 60 29.2929V4L100 44Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.88 56.3178V83.1995C56.88 83.9996 56.608 84.7116 56.0639 85.3356C55.5199 85.9597 54.8318 86.4437 53.9998 86.7877C53.1678 87.1317 52.3397 87.3877 51.5156 87.5557C50.6915 87.7238 49.9194 87.8078 49.1994 87.8077C48.4794 87.8077 47.7074 87.7237 46.8832 87.5557C46.0591 87.3878 45.2311 87.1318 44.399 86.7877C43.567 86.4436 42.879 85.9595 42.3349 85.3356C41.7908 84.7117 41.5188 83.9997 41.5188 83.1995C41.5188 82.3994 41.7908 81.6873 42.3349 81.0634C42.879 80.4395 43.567 79.9555 44.399 79.6114C45.2311 79.2673 46.0591 79.0112 46.8832 78.8433C47.7074 78.6754 48.4794 78.5914 49.1994 78.5913C50.8795 78.5913 52.4156 78.9033 53.8077 79.5274V66.6386L35.3745 72.327V89.3441C35.3745 90.1441 35.1025 90.8562 34.5584 91.4802C34.0143 92.1042 33.3263 92.5882 32.4942 92.9322C31.6622 93.2762 30.8341 93.5323 30.01 93.7003C29.1859 93.8684 28.4139 93.9524 27.6939 93.9523C26.9738 93.9522 26.2018 93.8682 25.3777 93.7003C24.5536 93.5324 23.7255 93.2764 22.8935 92.9322C22.0614 92.5881 21.3734 92.1041 20.8293 91.4802C20.2852 90.8563 20.0132 90.1442 20.0132 89.3441C20.0132 88.5439 20.2852 87.8319 20.8293 87.208C21.3734 86.5841 22.0614 86.1001 22.8935 85.7559C23.7255 85.4118 24.5536 85.1558 25.3777 84.9879C26.2018 84.8199 26.9738 84.7359 27.6939 84.7359C29.3739 84.7359 30.91 85.0479 32.3021 85.6719V62.4625C32.3021 61.9664 32.4541 61.5144 32.7581 61.1064C33.0621 60.6984 33.4542 60.4143 33.9342 60.2543L53.9035 54.1099C54.0955 54.0459 54.3195 54.0139 54.5756 54.0139C55.2156 54.0139 55.7596 54.2379 56.2076 54.686C56.6557 55.134 56.8797 55.678 56.8797 56.318L56.88 56.3178Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_62",
    x: 58,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_62",
    x1: 0,
    y1: 4,
    x2: 0,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE01"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesMusic);
export default __webpack_public_path__ + "static/media/files-music.638b2e597227edf065f45c2ad6de2550.svg";
export { ForwardRef as ReactComponent };